module.exports = __webpack_public_path__ + "img/menu-board-coq-frit.97e6e488.jpg";